<!--
 * @Autor: yzr
 * @Date: 2021-07-20 10:37:32
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-30 17:02:27
 * @Description: 分利协议主体列表
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import * as utils from '../../../utils/index';

export default {
  name: 'modules',
  extends: TablePage,
  data() {
    return {
      //   requestType: 'GET',
      //   requestUrl: '/cps/v1/barcode/scanCodeRecord/tj/requestCodeInfo',
      params: {},
      formConfig: {},
    };
  },
  async created() {
    await this.getConfigList('main-list');
  },
  mounted() {},
  methods: {
    beforeGetList() {
      if (!this.searchFormData.deliveryNo && !this.searchFormData.orderNo && !this.searchFormData.barCode) {
        this.$message.error('请输入查询条件');
        return false;
      }
      return true;
    },
  },
};
</script>
